<template>
<div>
    <header class="mdc-top-app-bar top-app-bar top-header">
        <div class="mdc-top-app-bar__row">
            <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                <button class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button hide-desktop navToggle"
                    aria-label="Open navigation menu">menu</button>
                <span class="mdc-top-app-bar__title t-subtitle4 pdl-12 cursor-pointer">{{bradName}}</span>
            </section>
            <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end" role="toolbar">
                <!-- <div class="profile d-flex align-items-center mgr-24"><img src="images/avtar.svg"
                        class="w-32 h-32 circle mgr-16" alt="">
                    <div class="t-body2 t-color-white">USER ID</div>
                </div> -->
                <div class=" t-body2 t-color-white pdr-18 cursor-pointer" @click.prevent="login" @keypress.prevent="login" tabindex="0">LOGIN</div>
                <!-- <div class=" t-body2 t-color-appbarText pdr-18 cursor-pointer">LOGOUT</div> -->
            </section>
        </div>
    </header>
    <div class="d-flex h-full flex-column">
        <main class="main-wrapper full flex-grow-1 scroll-y">

            <div class="container container--small pdt-50 ">

                <router-view></router-view>
            </div>

        </main>
    </div>
    </div>
</template>

<script>
/**
 * 아이디 찾기 메인 컴포넌트(find account main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '../mixins/topAppBar.js'
import localStorageUtil from "@/utils/localStorageUtil";

export default {
    name: 'findcode',
    data() {
        return {
            title: null,
			      bradName : localStorage.getItem('brandName'),
            isIdpService: localStorageUtil.isIdpServiceValidate()
        }
    },
    components: {
        TopAppBar
    },

    watch: {
        '$route' (to, from) {
            if (to.name === 'FindCodeStep1') {
                this.setTopAppBarCloseOnly('')
            }else if (to.name === 'FindCodeComplete') {
                this.setTopAppBarCloseOnlyMoveLogin('')
            }else {
                this.setTopAppBarBackOnly('')
            }
        }
    },

    mixins: [topAppBarMixin],

    mounted() {
        this.setTopAppBarCloseOnly()
    },

    methods: {
        setTopAppBarBackOnly(title) {
            this.leftBtnMode = 'arrow_back'
            this.rightBtnMode = ''
            this.title = title || this.title
            this.leftBtnMethod = () => {
                this.$router.go(-1)
            }
            this.rightBtnMethod = ''
        },

        setTopAppBarCloseOnly(title) {
            this.leftBtnMode = 'arrow_back'
            this.rightBtnMode = ''
            this.title = title || this.title
            this.leftBtnMethod = () => {
                this.$router.go(-1)
            }
            this.rightBtnMethod = ''
        },

        login() {
          if (this.isIdpService) {
            this.$moveIdpLogout();
          } else {
            this.$router.push("/login");
          }
		    }
    }
}
</script>
